import React from 'react';
import PropTypes from 'prop-types';
import { Spinner, } from 'react-bootstrap';
import _ from 'lodash';
import TransactionService from '../../../service/TransactionService';
import VerticalLabelList from '../../label/VerticalLabelList';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../modules/Constants';
import ObjectUtils from '../../../modules/ObjectUtils';
import TransactionNotes from './TransactionNotes';
import ServiceOfferingService from '../../../service/ServiceOfferingService';

class DetailedTransaction extends React.Component {
  constructor(props) {
    super(props);
    const { transaction, } = props;
    this.state = {
      transaction,
      serviceOfferingDetailHeaders: [],
      serviceOfferingDetailRows: [],
      paymentHistoryHeaders: [],
      paymentHistoryRows: [],
      isReady: false,
    };
    this.v2KeyExclusions = [ 'paymentHistory', 'transactionNotes', ];
  }

  componentDidMount() {
    this._mounted = true;
    const { transaction, } = this.props;
    TransactionService.getTransactionDetail(transaction.id)
      .then((response) => {
        const { data = {}, } = response;
        return data;
      })
      .then((data) => {
        const { paymentHistory, } = data.transaction;

        this.populateServiceOfferingDetails(data.transaction.serviceOfferingId);

        const formattedPaymentHistory = [];
        if (paymentHistory) {
          paymentHistory.forEach((item) => {
            formattedPaymentHistory.push({
              ...item,
              timeStamp: new Date(item.timeStamp * 1000).toISOString(),
            });
          });
        }

        const paymentHistoryModel = Grid.toModelFromList(formattedPaymentHistory, {
          headerFormatter: value => _.startCase(value.header),
        });

        if (this._mounted) {
          this.setState({
            transaction: data.transaction,
            paymentHistoryHeaders: paymentHistoryModel.headers,
            paymentHistoryRows: paymentHistoryModel.format(formattedPaymentHistory),
            isReady: true,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  async populateServiceOfferingDetails(serviceOfferingId) {
    const serviceOfferingDetailHeaders = [];
    const serviceOfferingDetailRows = [];
    const relevantDetails = [ 'id', 'displayName', 'created', 'description', 'active', 'zoneId', ];

    relevantDetails.forEach((detail) => {
      serviceOfferingDetailHeaders.push({
        display: _.startCase(detail),
        value: detail,
      });
    });

    await ServiceOfferingService.getServiceById({ id: serviceOfferingId, })
      .then((sosResponse) => {
        const serviceOfferingDetailData = sosResponse.data.service.data;
        const serviceOfferingDetailAttributes = sosResponse.data.service.data.attributes;
        const customServiceOfferingDetails = {
          id: serviceOfferingDetailData.id || 'Not found',
          displayName: serviceOfferingDetailAttributes.displayName || 'Not found',
          created: serviceOfferingDetailAttributes.created || 'Not found',
          description: serviceOfferingDetailAttributes.description || 'Not found',
          active: serviceOfferingDetailAttributes.active || 'Not found',
          zoneId: serviceOfferingDetailAttributes.zoneId || 'Not found',
        };

        serviceOfferingDetailRows.push({
          value: Object.values(customServiceOfferingDetails),
          raw: customServiceOfferingDetails,
        });
      }).catch(err => {
        console.error(err);
        serviceOfferingDetailRows.push({
          value: [ 'Error fetching service offering details', ],
          raw: { 'Error fetching service offering details': 'Error fetching service offering details', },
        });
      });

    this.setState({
      serviceOfferingDetailHeaders,
      serviceOfferingDetailRows,
    });
  }

  render() {
    const {
      transaction = {},
      paymentHistoryHeaders = [],
      paymentHistoryRows = [],
      serviceOfferingDetailHeaders = [],
      serviceOfferingDetailRows = [],
      isReady,
    } = this.state;

    let items;

    if (isReady) {
      items = VerticalLabelList.toList(transaction, {
        displayFormatter: (value) => {
          const formattedValue = value.split('_').join(' ');
          return _.startCase(formattedValue);
        },
      });
    }

    return (
      <>
        {(() => {
          if (isReady) {
            return (
              <>
                <FieldSet title="Transaction Summary" style={{ maxHeight: '400px', }}>
                  <VerticalLabelList items={items} exclusions={this.v2KeyExclusions} />
                </FieldSet>
                <FieldSet title="Payment History">
                  <Grid
                    headers={paymentHistoryHeaders}
                    rows={paymentHistoryRows}
                    onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
                  />
                </FieldSet>
                <FieldSet title="Service Offering ID Details">
                  <Grid headers={serviceOfferingDetailHeaders} rows={serviceOfferingDetailRows} />
                </FieldSet>
                <TransactionNotes
                  transactionNotes={ObjectUtils.formatStringAsJSONArray(
                    transaction.transactionNotes
                  )}
                />
              </>
            );
          }
          return (
            <div className="row justify-content-center">
              <Spinner animation="border" />
            </div>
          );
        })()}
      </>
    );
  }
}

DetailedTransaction.defaultProps = {};

DetailedTransaction.propTypes = {
  transaction: PropTypes.instanceOf(Object).isRequired,
};

export default DetailedTransaction;
